import { List, ListItem, Typography } from '@mui/material';

type TDocumentRequirementsListProps = {
  title?: string;
  documents: string[];
};

/**
 * Pure presentation component for rendering a list of document requirements.
 * Follows ADR 0078 for token usage - uses theme.semantic tokens for styling.
 */
export function DocumentRequirementsList({ title, documents }: TDocumentRequirementsListProps) {
  return (
    <>
      {title && (
        <Typography 
          variant="subtitle2" 
          sx={(theme) => ({ 
            mt: theme.semantic.spacing.base, 
            mb: theme.semantic.spacing.xs 
          })}
        >
          {title}
        </Typography>
      )}
      <List sx={(theme) => ({ 
        listStyle: 'disc', 
        pl: theme.semantic.spacing['2lg'], 
        py: 0, 
        m: 0 
      })}>
        {documents.map((doc) => (
          <ListItem
            key={doc}
            sx={(theme) => ({ 
              display: 'list-item', 
              py: theme.semantic.spacing['2xs'], 
              px: theme.semantic.spacing.xs 
            })}
          >
            <Typography variant="body2">{doc}</Typography>
          </ListItem>
        ))}
      </List>
    </>
  );
}
